/** Omits `quantity` entirely when absent, so legacy callers send the body they always sent. */
export const wishlistItemBody = (sku, meta, quantity) => {
  const body = { product_variant_sku: sku, meta }
  if (quantity != null) body.quantity = quantity
  return body
}
